module.exports = __webpack_public_path__ + "static/transforming-the-future-565c93d2e9e63e26729245e775a9ff25.jpg";